export default __webpack_public_path__ + "static/media/comfortHome.58600d78.jpg";